module.exports = __webpack_public_path__ + "static/media/star-rs.6744e50c.png";